import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    switchView() {
        if (window.getCookie('detailedView') === '' || parseInt(window.getCookie('detailedView')) !== 1) {
            window.setCookie('detailedView', 1, 180);
        } else {
            window.setCookie('detailedView', '', -1);
        }
        window.location.reload();
    }
}
